import React from "react";
import Header from "./Header";
import BeanMachine from "./BeanMachine";

export default function App() {
  return (
    <React.Fragment>
      <Header />
      <BeanMachine />
    </React.Fragment>
  );
}